import { render, staticRenderFns } from "./DisplayMessage.vue?vue&type=template&id=bad9aa3a&scoped=true&"
import script from "./DisplayMessage.vue?vue&type=script&lang=ts&"
export * from "./DisplayMessage.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayMessage.vue?vue&type=style&index=0&id=bad9aa3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad9aa3a",
  null
  
)

export default component.exports